"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = exports.scanAccounts = void 0;
const account_1 = require("../../account");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const api_1 = require("./api");
const sdk_1 = require("./api/sdk");
const sdk_2 = require("./api/sdk");
const kit = (0, sdk_1.celoKit)();
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, currency, initialAccount, derivationMode } = info;
    const oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
    const election = yield kit.contracts.getElection();
    const electionConfig = yield election.getConfig();
    const lockedGold = yield kit.contracts.getLockedGold();
    const accountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const { blockHeight, balance, spendableBalance, operations: newOperations, lockedBalance, nonvotingLockedBalance, } = yield (0, api_1.getAccountDetails)(address, accountId);
    const accountRegistrationStatus = yield (0, sdk_2.getAccountRegistrationStatus)(address);
    const pendingWithdrawals = accountRegistrationStatus ? yield (0, sdk_2.getPendingWithdrawals)(address) : [];
    const votes = accountRegistrationStatus ? yield (0, sdk_2.getVotes)(address) : [];
    const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    const shape = {
        id: accountId,
        balance,
        spendableBalance,
        operationsCount: operations.length,
        blockHeight,
        celoResources: {
            registrationStatus: accountRegistrationStatus,
            lockedBalance,
            nonvotingLockedBalance,
            pendingWithdrawals,
            votes,
            electionAddress: election.address,
            lockedGoldAddress: lockedGold.address,
            maxNumGroupsVotedFor: electionConfig.maxNumGroupsVotedFor,
        },
    };
    return Object.assign(Object.assign({}, shape), { operations });
});
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape });
//# sourceMappingURL=js-synchronisation.js.map